import React from 'react';
import { createTemplate } from '../../helpers/socialContentService';
import TemplateForm from './TemplateForm';

const TemplateModal = ({ isOpen, onClose, template = null, onSuccess }) => {
    if (!isOpen) return null;

    const handleSubmit = async (formData) => {
        try {
            await createTemplate(formData);
            onSuccess?.();
            onClose();
        } catch (error) {
            console.error('Error creating template:', error);
            // Aquí podrías manejar el error de una manera más amigable para el usuario
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
                <h2 className="text-xl font-bold mb-6">
                    {template ? 'Editar Plantilla' : 'Nueva Plantilla'}
                </h2>

                <TemplateForm
                    initialData={template}
                    onSubmit={handleSubmit}
                    onCancel={onClose}
                />
            </div>
        </div>
    );
};

export default TemplateModal; 